import { render } from "./index.vue?vue&type=template&id=3eb37eea&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3eb37eea&scoped=true&lang=css"

import exportComponent from "/home/vestment25/upgrading/jarvis-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb37eea"]])

export default __exports__